import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./MediaCarousel.css";

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div
      style={{
        position: "absolute",
        right: "15px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 20,
        fontSize: "30px",
        background: '#7500c0',
        width: "50px",
        height: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      ❯
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      style={{
        position: "absolute",
        left: "15px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 20,
        fontSize: "30px",
        background: '#7500c0',
        width: "50px",
        height: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        cursor: "pointer",

      }}
      onClick={onClick}
    >
      ❮
    </div>
  );
}

function MediaCarousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <Slider {...settings} className="my-slider">
      {/* Image Slide */}
      <div className="img-video-holder">
        <img
          src="/images/Frame 5.jpg"
          alt="slide1"
          className="all-journey-img"
        />
      </div>

      {/* Video Slide */}
      <div className="img-video-holder">
        <video className="journey-video" controls loop>
          <source src="/EntryLevelJourney.mp4" type="video/mp4" />
        </video>
      </div>

      {/* Image Slide */}
      <div className="img-video-holder">
        <img
          src="/images/Frame 10.jpg"
          alt="slide3"
          className="all-journey-img entry-level-last-img"
          id="img3"
        />
      </div>
    </Slider>
  );
}

export default MediaCarousel;
